import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
var useStyles = makeStyles(function () {
    return {
        root: {
            display: 'flex',
            alignItems: 'center'
        }
    };
});
export function PagePosition(_a) {
    var paginationState = _a.paginationState;
    var classes = useStyles();
    var min = paginationState.currentPage * paginationState.pageSize - (paginationState.pageSize - 1);
    var max = paginationState.currentPage * paginationState.pageSize;
    if (max > paginationState.itemCount) {
        max = paginationState.itemCount;
    }
    return (React.createElement(Typography, { variant: "body2", className: classes.root },
        min,
        " - ",
        max,
        " of ",
        paginationState.itemCount));
}
//# sourceMappingURL=PagePosition.js.map